<template>
  <div class="step-block__row row">
    <div class="step-block__input-row col-10 col-sm-12">
      <p><strong>Заполните данные получателя заказа</strong></p>
    </div>
    <div class="step-block__input-row col-10 col-sm-12">
      <div class="step-block__label">Название адреса*</div>
      <input type="text" class="inputbox" v-model="model.addressName">
      <div class="input-row__error" v-if="errors['data.addressName']">{{ errors['data.addressName']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">Имя</div>
      <input type="text" class="inputbox" v-model="model.name">
      <div class="input-row__error" v-if="errors['data.name']">{{ errors['data.name']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">Фамилия</div>
      <input type="text" class="inputbox" v-model="model.surName">
      <div class="input-row__error" v-if="errors['data.surName']">{{ errors['data.surName']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">E-mail</div>
      <input type="text" class="inputbox" v-model="model.email">
      <div class="input-row__error" v-if="errors['data.email']">{{ errors['data.email']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">Телефон</div>
      <input type="text" class="inputbox" v-model="model.phone">
      <div class="input-row__error" v-if="errors['data.phone']">{{ errors['data.phone']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">Выбрать город*</div>
      <select
          id="locationCode"
          class="nice-select--ajax nice-select--search nice-select--normal"
          data-js-placeholder="Начните вводить город"
          data-ajax="/api/locations/search/">

      </select>
      <div class="input-row__error" v-if="errors['data.locationCode']">{{ errors['data.locationCode']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">Индекс</div>
      <input type="text" class="inputbox" v-model="model.zip">
      <div class="input-row__error" v-if="errors['data.zip']">{{ errors['data.zip']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="step-block__label">Улица*</div>
      <input type="text" class="inputbox" v-model="model.street">
      <div class="input-row__error" v-if="errors['data.street']">{{ errors['data.street']['title'] }}</div>
    </div>
    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div class="row">
        <div class="col-4">
          <div class="step-block__label">Дом*</div>
          <input type="text" class="inputbox" v-model="model.house">
          <div class="input-row__error" v-if="errors['data.house']">{{ errors['data.house']['title'] }}</div>
        </div>
        <div class="col-4">
          <div class="step-block__label">Корпус</div>
          <input type="text" class="inputbox" v-model="model.building">
          <div class="input-row__error" v-if="errors['data.building']">{{ errors['data.building']['title'] }}</div>
        </div>
        <div class="col-4">
          <div class="step-block__label">Квартира</div>
          <input type="text" class="inputbox" v-model="model.apartments">
          <div class="input-row__error" v-if="errors['data.apartments']">{{ errors['data.apartments']['title'] }}</div>
        </div>
      </div>
    </div>

    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <div v-for="(error,k) in notValidationErrors" :key="k" class="input-row__error">{{ error.title }}</div>
    </div>

    <div class="step-block__input-row col-5 col-sm-6 col-xs-12">
      <a @click.prevent="saveDeliveryAddress()" class="btn btn--black btn--block btn--next btn--md">
        <span>Сохранить</span>
      </a>
    </div>

  </div>
</template>

<script>
    import api from '@/api/address';

    /* global $ */

    export default {
      name: 'ProfileAddress',
      props: {
        addressId: {
          type: String,
          default: function() {
            return '0';
          },
        },
      },
      data: function() {
        return {
          model: {
            addressName: '',
            name: '',
            surName: '',
            email: '',
            phone: '',
            locationCode: '',
            zip: '',
            street: '',
            house: '',
            building: '',
            apartments: '',
          },
          errors: {},
        }
      },
      computed: {
        notValidationErrors: function () {
          let errors = [];
          for (const k in this.errors) {
            const error = this.errors[k];
            if (error.code !== 'c1051bb4-d103-4f74-8988-acbcafc7fdc3') {
              errors.push(this.errors[k]);
            }
          }

          return errors;
        }
      },
      methods: {
        saveDeliveryAddress() {
          this.errors = {};

          api.edit(this.addressId, this.model, responseData => {
                if (responseData.errors) {
                  this.errors = responseData.errors;
                } else if (responseData.success === true) {
                  this.$router.push({ name: 'delivery-address' })
                } else {
                  this.errors = {'err': {'title': 'При сохранении произошла ошибка'}};
                }
              },
              err => {
                this.errors = err.response.data.errors;
              }
          );
        },
      },
      mounted() {
        const $select = $('#locationCode');

        $select.niceSelect();

        $select.change(() => {
          this.model.locationCode = $select.val();
        });

        if (this.addressId) {
          api.loadSingle(this.addressId, ({data}) => {

            this.model.addressName = data.ADDRESS_NAME;
            this.model.name = data.NAME;
            this.model.surName = data.SURNAME;
            this.model.email = data.EMAIL;
            this.model.phone = data.PHONE;
            this.model.locationCode = data.LOCATION_CODE;
            this.model.zip = data.ZIP;
            this.model.street = data.STREET;
            this.model.house = data.HOUSE;
            this.model.building = data.BUILDING;
            this.model.apartments = data.APARTMENTS;

            $select.val(data.LOCATION_CODE).niceSelect('update');
            $select.append(`<option value="${data.LOCATION_CODE}" selected>${data.LOCATION.DISPLAY}</option>`);

            $select.niceSelect('update');
          });
        } else {
          $select.niceSelect('update');
        }
      }
    }
</script>